import axios from 'axios';

export default class Account {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async getTheme(accountId) {
    const result = await axios.get(`${this.baseURL}/${accountId}/theme`);
    return result.data;
  }

  async getIntents(accountId) {
    const result = await axios.get(`${this.baseURL}/${accountId}/intents`);
    return result.data;
  }
}
